export const FunctionNames =  {
    GetServiceItems: 'GetServiceItems',
    GetProductItems: 'GetProductItems',
    GetCategoriesByCategoryId: 'GetCategoriesByCategoryId',
    GetItemsByCategoryId: 'GetItemsByCategoryId',
    GetItemByItemId: 'GetItemByItemId',
    GetAllTeamMembers: 'GetAllTeamMembers'
}